import { z } from "zod";

export const addNoteSchema = z
    .object({
        note: z.string(),
        tag: z.string(),
        caseTaskUUID: z.string().optional(),
        completeTask: z.boolean().optional(),

        enabled: z.boolean().optional(),
        title: z.string().optional(),
        priority: z.enum(["low", "medium", "high"]).optional(),
        sendEmail: z.boolean().optional(),
        notifyUsers: z.array(z.string()).optional(),
        addNoteToCompanions: z.boolean().optional(),
        selectedCompanions: z.array(z.string()).optional(),
    })
    .refine(
        (data) => {
            if (data.enabled === true) {
                return data.title && data.title.trim().length > 0;
            }
            return true;
        },
        {
            message: "Title is required when notifications are enabled",
            path: ["title"],
        },
    )
    .refine(
        (data) => {
            if (data.enabled === true) {
                return data.notifyUsers && data.notifyUsers.length > 0;
            }
            return true;
        },
        {
            message: "At least one user must be specified when notifications are enabled",
            path: ["notifyUsers"],
        },
    )
    .refine(
        (data) => {
            if (data.addNoteToCompanions === true) {
                return data.selectedCompanions && data.selectedCompanions.length > 0;
            }
            return true;
        },
        {
            message: "Please select at least one companion case or disable companion cases",
            path: ["selectedCompanions"],
        },
    );
